export default __webpack_public_path__ + "static/SR USA - Origin - Statement-478e39bda814fe8d47618e288ac32aa4.pdf";